var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownDocPart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46661 0.666659L6.99995 6.16666C6.99995 6.16666 6.99995 6.16666 7.04161 6.16666L12.5083 0.708326C12.6644 0.553117 12.8756 0.465999 13.0958 0.465999C13.3159 0.465999 13.5271 0.553117 13.6833 0.708326C13.8385 0.864461 13.9256 1.07567 13.9256 1.29583C13.9256 1.51598 13.8385 1.72719 13.6833 1.88333L7.60828 7.95833C7.45214 8.11354 7.24093 8.20065 7.02078 8.20065C6.80063 8.20065 6.58942 8.11354 6.43328 7.95833L0.33328 1.82499C0.18308 1.6696 0.0991211 1.46194 0.0991211 1.24583C0.0991211 1.02971 0.18308 0.822048 0.33328 0.666659C0.487376 0.523747 0.68978 0.444336 0.899946 0.444336C1.11011 0.444336 1.31252 0.523747 1.46661 0.666659Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDocPart);
export default __webpack_public_path__ + "static/media/arrow-down-doc-part.ab7d2500fe6101e41d89fbc8f9c6b72e.svg";
export { ForwardRef as ReactComponent };